module.exports = __webpack_public_path__ + "static/btoc-e12144d61182a6e5b3871c157a09422f.png";